export const ModaisTour = {
  modalWelcomeInicial: 'modalWelcomeInicial',
  modalVisaoGeral: 'modalVisaoGeral'
};
